// extracted by mini-css-extract-plugin
export var errorIcon = "_lj-1";
export var nameLogo = "_lj-0";